import { render, staticRenderFns } from "./UserScreen.vue?vue&type=template&id=0379ea69&scoped=true"
import script from "./UserScreen.vue?vue&type=script&lang=js"
export * from "./UserScreen.vue?vue&type=script&lang=js"
import style0 from "./UserScreen.vue?vue&type=style&index=0&id=0379ea69&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0379ea69",
  null
  
)

export default component.exports